import { useBrPageContext } from "../../context/context/context.js";
const useBloomreachPageName = () => {
  const page = useBrPageContext();
  return page?.getComponent().getName();
};
export {
  useBloomreachPageName
};
//# sourceMappingURL=use-bloomreach-page-name.js.map
